import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
const planillas = [{
  img: 'https://cdn.magicpatterns.com/uploads/8d6qBdsTqPbsAz4GxG2dJi/modu-3-34_page-0001.webp',
  tag: 'Módulo 3',
  title: 'Planilla Maestra de Corte de Perfiles PVC',
  desc: 'La hoja que llevás al taller para fabricar. Todos los perfiles, ángulos y largos en una sola página.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/7oLjb1XTCCfdCuoRmC8DuL/Pack-de-Aceleracion-PVC-DVH-18_page-0001.webp',
  tag: 'Pack de Aceleración',
  title: 'Ficha de Relevamiento — Detalle por Vano',
  desc: 'Mediciones en 3 puntos, verificaciones en obra y fotografías obligatorias. Una por cada vano.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/8xAjdWPDd9psuowAsxMcsg/Pack-de-Aceleracion-PVC-DVH-19_page-0001.webp',
  tag: 'Pack de Aceleración',
  title: 'Resumen de Todos los Vanos',
  desc: 'La planilla que llevás al taller. Todos los vanos, cristales y materiales de la obra en una sola hoja.'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/xA9HF7e4mvceSqNjrJ411e/modu-6-6_page-0001.webp',
  tag: 'Módulo 6',
  title: 'El Mapa de la Instalación Perfecta',
  desc: 'Las 8 etapas secuenciales de la instalación. Tu guía visual de referencia para cada obra.'
}];
// Duplicate the list so the marquee can loop seamlessly
const looped = [...planillas, ...planillas];
export function PlanillasPreview() {
  return <section className="py-16 md:py-20 bg-bg border-b border-white/5 overflow-hidden" aria-label="Vista previa de planillas" data-id="element-237">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-238">
        <FadeIn data-id="element-239">
          <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-240">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight" data-id="element-241">
              🔍 MIRÁ POR DENTRO LO QUE VAS A{' '}
              <span className="text-gold" data-id="element-242">USAR MAÑANA</span>
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-243">
              No son diapositivas. Son las planillas reales que vas a imprimir y
              pegar en el taller.
            </p>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.1} data-id="element-244">
        <div className="relative w-full group" style={{
        maskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)'
      }} data-id="element-245">
          <div className="flex gap-6 md:gap-8 marquee-track w-max" data-id="element-246">
            {looped.map((p, i) => <article key={i} className="group/card w-[280px] sm:w-[340px] md:w-[400px] shrink-0 bg-surface rounded-2xl border border-white/10 hover:border-gold/40 transition-colors duration-300 flex flex-col overflow-hidden" aria-hidden={i >= planillas.length ? true : undefined} data-id="element-247">
                <div className="relative bg-surfaceLight/40 p-4 md:p-5 border-b border-white/5" data-id="element-248">
                  <div className="absolute top-4 right-4 z-10" data-id="element-249">
                    <span className="text-[10px] md:text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-md bg-gold/15 text-gold border border-gold/40 backdrop-blur" data-id="element-250">
                      {p.tag}
                    </span>
                  </div>
                  <div className="aspect-[3/4] w-full overflow-hidden rounded-lg shadow-2xl shadow-black/40 ring-1 ring-black/20 bg-white" data-id="element-251">
                    <img src={p.img} alt={p.title} loading="lazy" decoding="async" className="w-full h-full object-cover object-top" data-id="element-252" />
                  </div>
                </div>
                <div className="p-5 md:p-6 flex-1 flex flex-col" data-id="element-253">
                  <h3 className="text-base md:text-lg font-heading font-bold text-white mb-2 leading-tight" data-id="element-254">
                    {p.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-255">
                    {p.desc}
                  </p>
                </div>
              </article>)}
          </div>
        </div>
      </FadeIn>

      <div className="container mx-auto px-4 max-w-6xl" data-id="element-256">
        <FadeIn delay={0.3} data-id="element-257">
          <div className="mt-12 text-center" data-id="element-258">
            <div className="inline-flex flex-wrap items-center justify-center gap-x-4 gap-y-2 bg-surface/60 border border-white/10 rounded-full px-8 py-4 text-sm text-gray-300" data-id="element-259">
              <span className="text-gold font-bold" data-id="element-260">240+ páginas</span>
              <span className="text-white/20" data-id="element-261">·</span>
              <span className="text-gold font-bold" data-id="element-262">6 módulos</span>
              <span className="text-white/20" data-id="element-263">·</span>
              <span className="text-gold font-bold" data-id="element-264">140+ tablas</span>
              <span className="text-white/20" data-id="element-265">·</span>
              <span data-id="element-266">Todo listo para imprimir</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}